import { utils, LitElement, html, broadcastReceiver } from './-global.min.js'

const { addToCart, reRenderShopifySections } = utils

document.addEventListener('DOMContentLoaded', function (e) {
    const customForm = document.querySelector('.js-custom-atc-form');

    if (!customForm) return;

    const variantInput = customForm.querySelector('[name="id"]');
    const quantityInput = customForm.querySelector('[name="quantity"]');
    const sellingPlanInput = customForm.querySelector('[name="selling_plan"]');
    const submitButton = customForm.querySelector('[type="submit"]');

    document.addEventListener('variant-available::change', (event) => {
        variantInput.value = event.detail.variant_id;
        console.log(`variant-available change: ${JSON.stringify(event.detail)}`);
    });

    customForm.addEventListener('submit', async function (event) {
        event.preventDefault();

        if (!variantInput || !variantInput.value) {
            console.warn('Missing variant ID');
            return;
        }

        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('loading');

        const item = {
            id: parseInt(variantInput.value),
            quantity: parseInt(quantityInput?.value) || 1,
        };

        if (sellingPlanInput && sellingPlanInput.value) {
            item.selling_plan = parseInt(sellingPlanInput.value);
        }

        const formData = {
            items: [item]
        };

        reRenderShopifySections(
            await addToCart(formData)
        )

        utils.toggle(document.body, ['mini-cart-is-active'])
        if (utils.isTablet()) {
            document.body.style.overflow = 'hidden'
        }

        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('loading');

    });
}); 